import NavbarGuest from '@/Components/NavbarGuest';
import { Transition } from '@headlessui/react';
import { router } from '@inertiajs/react';
import { useState, useEffect } from 'react';

export default function Guest({ children }) {
    const [transition, setTransition] = useState(true);

    router.on('start', (event) => {
        if(Object.keys(event.detail.visit.data).length === 0 && Object.keys(event.detail.visit.only).length === 0){
            setTransition(false);
        }
    })
    router.on('finish', (event) => {
        if(Object.keys(event.detail.visit.data).length === 0 && Object.keys(event.detail.visit.only).length === 0){
            setTransition(true)
        }
    })

    return (
        <div className="bg-light">
            <NavbarGuest />
            
            <div  className="min-h-[calc(100vh-72px)] flex flex-col sm:justify-center items-center pt-6 sm:pt-0">
                <Transition
                    appear={true}
                    show={transition}
                    enter="transition-all duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-all duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                
                >
                    <div className="max-w-screen-lg bg-white w-full flex justify-center items-center px-6 lg:px-20 py-[56px] shadow-main mx-auto">
                        {children}
                    </div>
                </Transition>
            </div>

        </div>
    );
}